"use client";

import React from "react";
import Link from "next/link";
import {Accordion, AccordionContent, AccordionItem, AccordionTrigger} from "@/components/ui/accordion";

interface CategorySubcategoryProps {
    title: string;
    slug: string;
    slugSezione: string;
    faqs: {
        _id: string;
        question: string;
        answer: string;
        slug: string;
    }[];
}

const CategorySubcategory: React.FC<CategorySubcategoryProps> = ({
                                                                     title,
                                                                     slug,
                                                                     slugSezione,
                                                                     faqs,
                                                                 }) => {
    return (
        <div className="mb-4">
            <Accordion type="single" collapsible className="w-full">
                <AccordionItem value="item-1">
                    <AccordionTrigger>{title}</AccordionTrigger>
                    <AccordionContent>
                        {/*LISTA SOTTOCATEGORIE*/}
                        {faqs.map((faq) => (
                            <div key={faq._id} className="pl-4">
                                <h4 className="font-medium mt-4">
                                    <Link hrefLang="it" title={faq.question} href={`/faq/${slugSezione}/${slug}/${faq.slug}`}>
                                        <p>{faq.question}</p>
                                    </Link>
                                </h4>
                            </div>
                        ))}
                    </AccordionContent>
                </AccordionItem>
            </Accordion>
        </div>
    );
};

export default CategorySubcategory;
